import { iCompetenciaPDI } from '../../../../../interfaces'
import { Container } from './styles'

interface iTabelaProps {
  dados: iCompetenciaPDI[]
}

export const TabelaCompetencias: React.FC<iTabelaProps> = ({ dados }) => {
  return (
    <Container>
      <thead>
        <tr>
          <th>Competências</th>
          <th>Total de colaboradores</th>
        </tr>
      </thead>
      <tbody>
        {
          dados.slice(0, 6).map((e, i) => {
            return (
              <tr key={i}>
                <th>{e.nome}</th>
                <th>{e.colaboradores}</th>
              </tr>
            )
          })
        }
      </tbody>
    </Container>
  )
}
